import { ChevronLeft, Home } from 'lucide-react';
import { navigate } from '@/hooks/useRouter';
import { cn } from '@/utils/cn';

export interface NavBarProps {
  title?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClickLeft?: () => void;
  onClickRight?: () => void;
  className?: string;
}

const NavBar = ({ title, leftIcon, rightIcon, onClickLeft, onClickRight, className }: NavBarProps) => {
  // 默认行为：左键返回历史，右键返回首页
  const handleLeftClick = onClickLeft || (() => window.history.back());
  const handleRightClick = onClickRight || (() => navigate('/'));

  return (
    <nav
      className={cn(
        'fixed top-0 left-1/2 -translate-x-1/2 z-50',
        'flex items-center justify-center',
        'h-14 px-4 w-full max-w-[460px]',
        'bg-white text-text-primary',
        className,
      )}
    >
      <button
        onClick={handleLeftClick}
        className="absolute left-4 flex items-center justify-center w-8 h-8 hover:bg-black/10 rounded-full transition-colors"
        aria-label="返回"
      >
        {leftIcon || <ChevronLeft size={24} />}
      </button>
      {title && <h1 className="text-lg font-semibold">{title}</h1>}
      <button
        onClick={handleRightClick}
        className="absolute right-4 flex items-center justify-center w-8 h-8 hover:bg-black/10 rounded-full transition-colors"
        aria-label="返回主页"
      >
        {rightIcon || <Home size={24} />}
      </button>
    </nav>
  );
};

export default NavBar;
